export const productShortName = 'Industrial Electric Motors & Drives — Professional Edition™';
export const productBrand = 'Industrial Electric Motors & Drives';
export const productEdition = 'Professional Edition™';
export const productImage = 'https://cdn.magicpatterns.com/uploads/s1wSGysmfQzxAZLxkrK4Cu/MOCKUP_MOTORS.png';
export const productImageAlt =
  'Industrial Electric Motors & Drives Professional Edition: a six-volume technical collection in navy and gold hardcover';

export const checkoutUrl = 'https://industrial-electric-motors-drives.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70';

export const closingLines = [
  'No more guessing why a motor trips or overheats',
  'No more uncertainty when selecting, starting or protecting a motor',
  'No more confusion with VFD parameters and fault codes',
  'No more repeated failures without finding the root cause',
  'No more feeling unprepared in front of your next motor or drive',
];
